import gql from "graphql-tag";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import { layoutOptionsVar } from "../../../graphql/reactiveVariables";
import { getRoutePath } from "../../../router";
import Presenter from "./presenter";

interface AssetsReportPageProps {}

const AssetsReportPage: React.FC<AssetsReportPageProps> = () => {
  useEffect(() => {
    layoutOptionsVar({
      title: "Assets",
      hideSearch: true,
      styleProps: { paddingX: "0", pb: "0" },
      headerStyleProps: { paddingX: { base: "0", lg: "4" } },
      backLink: getRoutePath("reports"),
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Assets</title>
      </Helmet>
      <Presenter />
    </>
  );
};

export default AssetsReportPage;

gql`
  query ReportAsset($filterBy: ReportAssetFilterInput!, $timezone: String) {
    reportAsset(filterBy: $filterBy, timezone: $timezone)
  }
`;

gql`
  mutation CreateReportAsset(
    $fileType: ReportFileType!
    $filterBy: ReportAssetFilterInput!
    $timezone: String
  ) {
    createReportAsset(
      fileType: $fileType
      filterBy: $filterBy
      timezone: $timezone
    )
  }
`;
